import Heading from '@/components/atoms/Heading';
import * as S from './styles';
import Text from '@/components/atoms/Text';
import { useEffect, useState } from 'react';
import { Produto } from '@/types/produto';
import ListagemProdutosHome from '../ListagemProdutosHome';
import { listarProdutos } from '@/services/marketplaceService';
import { useTheme } from 'styled-components';
import useBreakpoint, { breakpointDesktopDefault } from '@/hooks/useBreakpoint';

interface ListagemItensBuscaProps {
  $termoBusca: string;
  $funcaoAdicional?: () => void;
}

export default function ListagemItensBusca(props: ListagemItensBuscaProps) {
  const { $termoBusca, $funcaoAdicional = undefined } = props;
  const theme = useTheme();
  const { breakpoint } = useBreakpoint();
  const [carregandoItensBusca, setCarregandoItensBusca] = useState(false);
  const [resultadosBusca, setResultadosBusca] = useState<Produto[]>([]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if ($termoBusca) {
        setCarregandoItensBusca(true);
        listarProdutos({
          filtros: `nome.Contains("${$termoBusca}") && somenteBeneficio == false`,
        })
          .then((dados) => {
            setResultadosBusca(dados);
          })
          .catch(() => {
            /* empty */
          })
          .finally(() => {
            setCarregandoItensBusca(false);
          });
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [$termoBusca]);

  return (
    <S.Container $breakpoint={breakpoint} style={breakpointDesktopDefault}>
      <S.Label>
        <Heading
          $priority={4}
          $size={3}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text="Resultado da busca por: "
        />
        <Text
          $size={2}
          $color="neutral"
          $weight="medium"
          $align="left"
          $highContrast={true}
          $text={$termoBusca}
        />
      </S.Label>
      <ListagemProdutosHome
        $loading={carregandoItensBusca}
        $produtos={resultadosBusca}
        $funcaoAdicional={$funcaoAdicional}
        style={{
          padding: `0 ${theme.spacing[5]}px`,
        }}
      />
    </S.Container>
  );
}
